import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from 'src/base/BaseComponent';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} from "react-google-maps";
import { HotelBedCatalogData } from 'src/shared';
import { getAjaxhelper } from 'src/utils';
const styles: any = [
    {
        featureType: 'poi.business',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }]
    }];
const MapWithAMarker = withScriptjs(withGoogleMap((props: any) => (
    <GoogleMap
        defaultZoom={15}
        defaultCenter={props.defaultCenter}
        defaultOptions={{ styles: styles }}
    >
        <Marker
            position={props.defaultCenter}
            icon={{ url: 'https://storage.googleapis.com/bali-hotel-images/Googlemap-pin-blue.png' }}
        />
    </GoogleMap>
)));

export interface HotelMapProps extends BaseComponentProps {
    defMapCenter: {
        lat: number;
        lng: number;
    };
    hotelId: number;
}
export interface HotelMapState extends BaseComponentState {
    data: HotelBedCatalogData.HotelsInterestPoints[];
    requesting: boolean;
}

export class HotelMap extends BaseComponent<HotelMapProps, HotelMapState> {
    constructor(props: HotelMapProps) {
        super(props);
        this.state = {
            data: [],
            requesting: true
        };
    }
    getData = () => {
        getAjaxhelper().get(`/dynamics/hb-api/interest-point-hotel/${this.props.hotelId}`).then(
            (data: any) => {
                this.setState({ requesting: false, data });
            }).catch((exc) => { console.error('error: ', exc); });
    }
    componentDidMount() {
        this.getData();
    }
    render() {
        let distance: any[] = [];
        if (this.state.requesting === false) {
            if (this.state.data) {
                for (let i of this.state.data) {
                    distance.push(
                        <tr>
                            <td>{i.poiName}</td><td>{i.distance as any / 1000} Km</td>
                        </tr>
                    );
                }
            }
        }
        let classMap = "col-md-8";
        let classDistance = 'col-md-4';
        if (distance.length === 0) {
            classMap = 'col-md-12';
            classDistance = 'hide';
        }
        return (
            <div>
                <div className='row' />
                <div className={classMap} style={{ padding: 0 }}>
                    <MapWithAMarker
                        defaultCenter={this.props.defMapCenter}
                        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAwKQXrpCCyjwljuwmbdhvxaeQ5dZi5DF8&v=3.exp&libraries=geometry,drawing,places"
                        loadingElement={<div style={{ height: `200px`, position: 'relative' }} ><div className='loader' /></div>}
                        containerElement={<div style={{ height: `400px` }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        defaultVisible={false}
                        defaultIcon={false}
                    />
                </div>
                <div className={classDistance} style={{ paddingTop: 15, paddingBottom: 15 }}>
                    <h3><i className="ti-location-pin" style={{ color: '#ff0000' }} /> Distance: </h3>
                    <table className="table table-striped" style={{border: '1px solid #d2d2d2'}}>
                        <tbody>{distance}</tbody> 
                    </table>

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/details/HotelMap.tsx